import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/';
import { HttpClient } from '@angular/common/http';
import { SuzyRequest, SuzyEndpoints } from '@asksuzy/typescript-sdk';
import { DeviceService } from '@suzy/shared/tools/device';
import {
  Sdk,
  SdkService,
  SdkHelper,
  ApiCredentials
} from '@suzy/shared/data-access/sdk';
import { VerisoulService } from '@suzy/shared/data-access/tracking';
export * from '@asksuzy/typescript-sdk';

@Injectable({ providedIn: 'root' })
export class SuzySdkService extends SuzyEndpoints implements Sdk {
  baseUrl: string;
  apiKeys: ApiCredentials;
  sdkHelper: SdkHelper;
  defaultError =
    'Crowdtap is experiencing performance issues - Please try again later.';

  constructor(
    private http: HttpClient,
    private deviceService: DeviceService,
    private verisoulService: VerisoulService
  ) {
    super();
    this.sdkHelper = new SdkHelper(
      this,
      this.http,
      this.deviceService,
      this.verisoulService
    );
  }

  getApiCredentials(): ApiCredentials {
    return this.sdkHelper.getApiCredentials();
  }

  setApiCredentials(apiKey: string, apiSecret: string): void {
    const apiCredentials = {
      api_key: apiKey,
      api_secret: apiSecret
    };

    this.sdkHelper.setApiCredentials(apiCredentials);
  }

  clearApiCredentials(): void {
    this.sdkHelper.clearApiCredentials();
  }

  initialize(baseUrl = '/api'): SdkService {
    return this.sdkHelper.initialize(baseUrl);
  }

  execute(request: SuzyRequest): Observable<any> {
    return this.sdkHelper.execute(request);
  }
}
